import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_works } from '@store/works.slice';
import WorksList from '@components/WorksList';

const Works = () => {
  const { works, is_fetching_works } = useSelector((state) => state.works);
  const dispatch = useDispatch();

  useEffect(() => {
    if (works.length === 0) {
      fetch();
    }
  }, []);

  const fetch = async () => {
    if (!is_fetching_works) {
      await dispatch(fetch_works());
    }
  };

  const WorkComponentsList = useMemo(() => {
    return (
      <WorksList
        works={works}
        is_fetching_works={is_fetching_works}
        fetch={fetch}
        title="Work"
        path="works"
      />
    );
  }, [works]);

  return <>{WorkComponentsList}</>;
};

export default Works;
